export interface DrawSummaryItem {
  scheduledValue: number
  previousCompleted: number
  thisperiodCompleted: number
  storedMaterials: number
}

export interface CalculatedDrawLine extends DrawSummaryItem {
  totalCompletedAndStored: number
  percentComplete: number
}

export interface CalculatedDrawSummary {
  adjustedContractSum: number
  scheduledTotal: number
  previousCompletedTotal: number
  thisPeriodTotal: number
  storedMaterialsTotal: number
  totalCompletedAndStored: number
  retainageAmount: number
  amountDue: number
  percentComplete: number
}

function roundCurrency(value: number) {
  return Math.round((value || 0) * 100) / 100
}

export function calculateDrawLine(item: DrawSummaryItem): CalculatedDrawLine {
  const scheduledValue = item.scheduledValue || 0
  const previousCompleted = item.previousCompleted || 0
  const thisperiodCompleted = item.thisperiodCompleted || 0
  const storedMaterials = item.storedMaterials || 0
  const totalCompletedAndStored = previousCompleted + thisperiodCompleted + storedMaterials

  return {
    scheduledValue,
    previousCompleted,
    thisperiodCompleted,
    storedMaterials,
    totalCompletedAndStored: roundCurrency(totalCompletedAndStored),
    percentComplete: scheduledValue > 0 ? Math.round((totalCompletedAndStored / scheduledValue) * 100) : 0,
  }
}

export function calculateDrawSummary(input: {
  contractSum: number
  changeOrderTotal: number
  retainagePercent: number
  items: DrawSummaryItem[]
}): CalculatedDrawSummary {
  const lines = input.items.map(calculateDrawLine)
  const scheduledTotal = lines.reduce((sum, item) => sum + item.scheduledValue, 0)
  const previousCompletedTotal = lines.reduce((sum, item) => sum + item.previousCompleted, 0)
  const thisPeriodTotal = lines.reduce((sum, item) => sum + item.thisperiodCompleted, 0)
  const storedMaterialsTotal = lines.reduce((sum, item) => sum + item.storedMaterials, 0)
  const totalCompletedAndStored = lines.reduce((sum, item) => sum + item.totalCompletedAndStored, 0)
  const adjustedContractSum = (input.contractSum || 0) + (input.changeOrderTotal || 0)
  const retainageAmount = totalCompletedAndStored * ((input.retainagePercent || 0) / 100)

  return {
    adjustedContractSum: roundCurrency(adjustedContractSum),
    scheduledTotal: roundCurrency(scheduledTotal),
    previousCompletedTotal: roundCurrency(previousCompletedTotal),
    thisPeriodTotal: roundCurrency(thisPeriodTotal),
    storedMaterialsTotal: roundCurrency(storedMaterialsTotal),
    totalCompletedAndStored: roundCurrency(totalCompletedAndStored),
    retainageAmount: roundCurrency(retainageAmount),
    amountDue: roundCurrency(totalCompletedAndStored - retainageAmount - previousCompletedTotal),
    percentComplete: adjustedContractSum > 0 ? Math.round((totalCompletedAndStored / adjustedContractSum) * 100) : 0,
  }
}
